module.exports = __webpack_public_path__ + "static/img/6.7df5ab4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carousel-2/6.jpg
// module id = mq7d
// module chunks = 1